import {
    APIResponse,
    FactoryEquipmentDto,
    VehicleGroupDto,
} from "@/shared/api-contract/api-contract";
import { pageLoaderModel } from "@/shared/models/page-loader";
import { Model, Prop, Vue } from "vue-property-decorator";
import { routerModel } from "@/router/router.model";
import { appAxios } from "@/core/utils/appAxios";
import { eff } from "@/core/utils/effect-ts-abbr";
import { shallowRef, watch } from "vue";
import { sessionModel } from "@/shared/state/session.model";
import { setup } from "vue-class-component";

export class VehicleFactoryEquipment extends Vue {
    @Prop({ default: () => {} })
    getVehicleFactoryEquipments!: (equipments: string[]) => void;
    @Model("vehicleId", { required: true })
    vehicleId!: number;
    factoryEquipmentDto = setup(() => shallowRef<undefined | FactoryEquipmentDto>());
    pageLoader = pageLoaderModel;
    beforeMount() {
        this.pageLoader.toggle(true);
    }

    async mounted() {
        watch(
            () => ({ vehicleId: this.vehicleId }),
            async () => {
                if (this.vehicleId > 0) {
                    const response = await this.fetchFactoryEquipmentDtos(this.vehicleId);
                    this.factoryEquipmentDto = response.data[0];
                    if (this.getVehicleFactoryEquipments) {
                        this.getVehicleFactoryEquipments(
                            this.factoryEquipmentDto?.equipments || [],
                        );
                    }
                    this.pageLoader.toggle(false);
                }
            },
        );
    }

    get leftSideEquipment() {
        return eff.fn.pipe(
            this.factoryEquipmentDto?.equipments || [],
            eff.array.filterWithIndex((index, _equipment) => index % 2 === 0),
        );
    }
    get rightSideEquipment() {
        return eff.fn.pipe(
            this.factoryEquipmentDto?.equipments || [],
            eff.array.filterWithIndex((index, _equipment) => index % 2 !== 0),
        );
    }

    /* API Connectivity --------------------------------------------------------------------------------------------- */
    async fetchFactoryEquipmentDtos(
        vehicleId: number,
    ): Promise<APIResponse<FactoryEquipmentDto>> {
        const isAuthenticated = sessionModel.sessionDto.value?.token;
        const suffix = isAuthenticated ? "vehicles" : "public/vehicles";

        const response = await appAxios.value.get<APIResponse<FactoryEquipmentDto>>(
            `/client/web/${suffix}/${vehicleId}/factory-equipment`,
        );
        return response.data;
    }
}
